import React from 'react'
import './App.css'
import './Editprofile.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { IoIosArrowBack } from 'react-icons/io'
import { IoPersonOutline, IoShareSocialOutline } from 'react-icons/io5'
import { BiMenu } from 'react-icons/bi'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

class Editprofile extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      accountname: '',
      phone: '',
      email: '',
      facebook: '',
      twitter: '',
      instagram: '',
      linkedin: '',
      tiktok: '',
      address: '',
      spinning: 'none',
      updateDisplay: 'block',
      updated_at: '',
      loggedAccountType: '',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    // alert(localStorage.getItem("partnername"));
    if (localStorage.getItem('customername') !== null) {
      const customername = localStorage.getItem('customername')
      const customerid = localStorage.getItem('customerid')
      document.title = 'Edit profile - ' + customername + ' - Customer'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            accountname: response.data.customername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            updated_at: response.data.updated_at,
            loggedAccountType: response.data.loggedAccountType,
          })
        })
        .catch(function (error) {
          alert(error)
        })
    } else if (localStorage.getItem('businessname') !== null) {
      const businessname = localStorage.getItem('businessname')
      const businessid = localStorage.getItem('businessid')
      document.title = 'Edit profile - ' + businessname + ' - Business'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS&accountid=${businessid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            accountname: response.data.businessname,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            facebook: response.data.facebook,
            twitter: response.data.twitter,
            instagram: response.data.instagram,
            linkedin: response.data.linkedin,
            tiktok: response.data.tiktok,
            address: response.data.address,
            updated_at: response.data.updated_at,
            loggedAccountType: response.data.loggedAccountType,
          })
        })
        .catch(function (error) {
          alert(error)
        })
    } else {
      const partnername = localStorage.getItem('partnername')
      const partnerid = localStorage.getItem('partnerid')
      document.title = 'Edit profile - ' + partnername + ' - Sales partner'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            accountname: response.data.partnername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            updated_at: response.data.updated_at,
            facebook: response.data.facebook,
            twitter: response.data.twitter,
            instagram: response.data.instagram,
            linkedin: response.data.linkedin,
            tiktok: response.data.tiktok,
            loggedAccountType: response.data.loggedAccountType,
          })
        })
        .catch(function (error) {
          alert(error)
        })
    }
  }

  handleCustomername = (event) => {
    this.setState({
      accountname: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEmail = (event) => {
    this.setState({
      email: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePhone = (event) => {
    this.setState({
      phone: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleFacebook = (event) => {
    this.setState({
      facebook: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTwitter = (event) => {
    this.setState({
      twitter: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleInstagram = (event) => {
    this.setState({
      instagram: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleLinkedin = (event) => {
    this.setState({
      linkedin: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTiktok = (event) => {
    this.setState({
      tiktok: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleAddress = (event) => {
    this.setState({
      address: event.target.value,
      errorDisplay: 'none',
    })
  }

  update = () => {
    let accountid = 0
    this.setState({ updateDisplay: 'none', spinning: 'block' })
    const accounttype = localStorage.getItem('accounttype')
    const phone = this.state.phone
    const email = this.state.email

    if (
      this.state.accountname.trim() == '' ||
      this.state.email.trim() == '' ||
      this.state.phone == ''
    ) {
      this.setState({ updateDisplay: 'block', spinning: 'none' })
      this.setState({
        error: 'All fields are required',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else {
      const baseURL = `${API_URL}/apps/kscanner/webservices.php`
      const data = new FormData()
      data.append('accountname', this.state.accountname)
      data.append('phone', this.state.phone)
      data.append('email', this.state.email)
      data.append('facebook', this.state.facebook)
      data.append('twitter', this.state.twitter)
      data.append('instagram', this.state.instagram)
      data.append('linkedin', this.state.linkedin)
      data.append('tiktok', this.state.tiktok)
      data.append('address', this.state.address)
      data.append('query', 'EDITACCOUNTDETAILS')
      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          this.setState({ updateDisplay: 'block', spinning: 'none' })
          let assignClass = ''
          if (response.data.status === 'failed') {
            assignClass = 'error-login'
          } else {
            assignClass = 'success-login'
          }
          this.setState({
            error: response.data.message,
            errorDisplay: 'block',
            successError: assignClass,
          })

          setTimeout(() => {
            this.setState({ errorDisplay: 'none' })
          }, 4000)
        })
        .catch(function (error) {
          console.log(error)
          // this.setState({
          //   error: error,
          //   errorDisplay: "block",
          //   successError: "error-login",
          // });

          setTimeout(() => {
            this.setState({ errorDisplay: 'none' })
          }, 4000)
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  /* Update button — same behaviour everywhere it is used */
  renderUpdateButton = () => (
    <button
      type="button"
      disabled={this.state.spinning === 'block' ? true : false}
      className={`ep-btn ${this.state.spinning === 'block' ? 'ep-btn--off' : 'ep-btn--primary'}`}
      onClick={() => this.update()}
    >
      <span
        style={{
          display: this.state.updateDisplay,
        }}
      >
        Update
      </span>
      <span
        style={{
          display: this.state.spinning,
        }}
      >
        <ClipLoader color={'grey'} loading={true} size={20} />
      </span>
    </button>
  )

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = localStorage.getItem('partnername')
          dashboard = 'in'
        }
      } else {
        accountname = localStorage.getItem('businessname')
        dashboard = 'dashboard'
      }
    } else {
      accountname = localStorage.getItem('customername')
      dashboard = 'customerdashboard'
    }
    const customername = accountname
    const dtregistered = this.props.location.state.dtregistered

    const accounttype = localStorage.getItem('accounttype')

    const { collapsed, isMobile } = this.state
    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}

        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}

        {this.state.isMobile && this.state.collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <main
          className="ep-page"
          style={{
            marginTop: 'var(--header-h)',
            marginLeft: this.state.isMobile ? 0 : this.state.collapsed ? '76px' : '252px',
          }}
        >
          <div className="ep-container">
            <button type="button" className="ep-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <div className="ep-head">
              <h1>Edit profile</h1>
              <p>Keep your details up to date.</p>
            </div>

            {/* Details */}
            <section className="ep-card">
              <div className="ep-card__head">
                <h2>
                  <IoPersonOutline size={18} />
                  Details
                </h2>
              </div>

              <div className="ep-form">
                <label className="ep-field ep-field--wide">
                  <span>
                    {localStorage.getItem('customername')
                      ? 'Name and surname'
                      : localStorage.getItem('businessname')
                        ? 'Business name'
                        : 'Name and surname'}
                  </span>
                  <input
                    type="text"
                    placeholder={
                      localStorage.getItem('customername') ? 'Name and surname' : 'Business name'
                    }
                    value={this.state.accountname}
                    onChange={this.handleCustomername}
                    className="ep-input"
                  />
                </label>

                <label className="ep-field">
                  <span>Email</span>
                  <input
                    type="email"
                    placeholder="Email address"
                    value={this.state.email}
                    onChange={this.handleEmail}
                    className="ep-input"
                  />
                </label>

                <label className="ep-field">
                  <span>Phone number</span>
                  <input
                    type="text"
                    placeholder="Phone number"
                    value={this.state.phone}
                    onChange={this.handlePhone}
                    className="ep-input"
                  />
                </label>
              </div>

              {localStorage.getItem('customername') ? (
                <div className="ep-foot">{this.renderUpdateButton()}</div>
              ) : (
                ''
              )}
            </section>

            {/* Social accounts (business / partner) */}
            {localStorage.getItem('customername') ? (
              ''
            ) : (
              <section className="ep-card">
                <div className="ep-card__head">
                  <div>
                    <h2>
                      <IoShareSocialOutline size={18} />
                      Social accounts
                    </h2>
                    <p>Make it easy for your attendees to find you</p>
                  </div>
                </div>

                <div className="ep-form">
                  <label className="ep-field ep-field--wide">
                    <span>Facebook profile URL</span>
                    <input
                      type="text"
                      placeholder="https://facebook.com/username"
                      value={this.state.facebook}
                      onChange={this.handleFacebook}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>X handle</span>
                    <input
                      type="text"
                      placeholder="https://x.com/username"
                      value={this.state.twitter}
                      onChange={this.handleTwitter}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>Instagram handle</span>
                    <input
                      type="text"
                      placeholder="https://instagram.com/username"
                      value={this.state.instagram}
                      onChange={this.handleInstagram}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>Linkedin profile URL</span>
                    <input
                      type="text"
                      placeholder="https://linkedin.com/in/username"
                      value={this.state.linkedin}
                      onChange={this.handleLinkedin}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>Tiktok handle</span>
                    <input
                      type="text"
                      placeholder="https://www.tiktok.com/username"
                      value={this.state.tiktok}
                      onChange={this.handleTiktok}
                      className="ep-input"
                    />
                  </label>

                  {this.state.loggedAccountType !== 'business' ? (
                    ''
                  ) : (
                    <label className="ep-field ep-field--wide">
                      <span>Business address</span>
                      <textarea
                        value={
                          this.state.address == 'null' || this.state.address == null
                            ? ''
                            : this.state.address
                        }
                        onChange={this.handleAddress}
                        placeholder="Address"
                        className="ep-input ep-textarea"
                        rows={3}
                      />
                    </label>
                  )}
                </div>

                <div className="ep-foot">{this.renderUpdateButton()}</div>
              </section>
            )}
          </div>
        </main>

        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
      </div>
    )
  }
}

export default Editprofile
